

























































































































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import MainTwoComponents from '@/components/layout/Main-2.vue';
import BgThemePublic from '@/components/bg-theme-public.vue';

@Component({
  components: {
    MainTwoComponents,
    BgThemePublic
  }
})
export default class TimeBankComponent extends Vue {

}
